"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9635],{

/***/ 20932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ A; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          color: ",
        ";\n          text-decoration: ",
        ";\n          &:hover {\n            text-decoration: underline;\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var A = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Anchor(props, ref) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), props.color || plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, props.decoration || "underline"),
        ref: ref,
        "data-test-id": props.dataTestId
    }, props));
});


/***/ }),

/***/ 44117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ CheckIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96747);



var CheckIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_1__/* .IcomoonIcon */ .g, {
        name: "check",
        className: props.className
    });
};


/***/ }),

/***/ 84044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ LoadableButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);






var LoadableButton = function(_param) {
    var _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _spinnerColor = _param.spinnerColor, spinnerColor = _spinnerColor === void 0 ? plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.border */ .O9.border : _spinnerColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "isLoading",
        "spinnerColor"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .zx, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        css: isLoading && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("color:transparent !important;position:relative;pointer-events:none;&::after{animation:", spinAround, " 500ms infinite linear;border:2px solid ", spinnerColor, ";border-radius:50%;border-right-color:transparent;border-top-color:transparent;content:'';display:block;height:1em;position:absolute;width:1em;position:absolute;left:calc(50% - (1em / 2));top:calc(50% - (1em / 2));position:absolute !important;}")
    }, props));
};
var spinAround = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)("@keyframes spinAround\n  from{transform:rotate(0deg);}to{transform:rotate(359deg);}");


/***/ }),

/***/ 14792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SC": function() { return /* binding */ TableRow; },
/* harmony export */   "cq": function() { return /* binding */ TableHeading; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "pj": function() { return /* binding */ TableCell; },
/* harmony export */   "ss": function() { return /* binding */ TableHead; },
/* harmony export */   "vQ": function() { return /* binding */ SubLabel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _common_Help__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33869);








var Table = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("table", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        id: props.id,
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{display:block;white-space:nowrap;overflow-x:auto;}background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";width:100%;/* This style is necessary to use sticky header */\n        border-collapse:separate;border-spacing:0;thead{border-bottom:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray40 */ .O9.gray40, ";border-collapse:collapse;}th,td{border-bottom:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray50 */ .O9.gray50, ";}th{font-size:13px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";white-space:nowrap;padding:1rem 0.8rem 1rem 0.8rem;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{padding-left:0.5rem;padding-right:0.5rem;}}")
    }, props));
};
var TableHead = function(props) {
    var _offset;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("thead", {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("th{position:", props.sticky ? "sticky" : "static", ";top:", (_offset = props.offset) !== null && _offset !== void 0 ? _offset : 0, ";}"),
        "data-test-id": props.dataTestId,
        children: props.children
    });
};
var TableRow = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("tr", {
        css: props.highlightOnHover && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("transition:0.3s;&:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white10 */ .O9.white10, ";}"),
        className: props.className,
        "data-appcues": props["data-appcues"],
        children: props.children
    });
};
var TableCell = function(_param) {
    var _omitted = _param.omitted, omitted = _omitted === void 0 ? false : _omitted, _nowrap = _param.nowrap, nowrap = _nowrap === void 0 ? false : _nowrap, _align = _param.align, align = _align === void 0 ? "left" : _align, _vertical = _param.vertical, vertical = _vertical === void 0 ? "top" : _vertical, _centerized = _param.centerized, centerized = _centerized === void 0 ? false : _centerized, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "omitted",
        "nowrap",
        "align",
        "vertical",
        "centerized"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("td", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-size:14px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black30 */ .O9.black30, ";line-height:1.5;padding:0.8rem;text-align:", centerized ? "center" : align, ";vertical-align:", centerized ? "middle" : vertical, ";", props.width && "width: ".concat(props.width, ";"), " ", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{padding-left:0.5rem;padding-right:0.5rem;}"),
        colSpan: props.colSpan || 1,
        rowSpan: props.rowSpan || 1,
        className: props.className,
        "data-test-id": props.dataTestId,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.untilMedium, "{white-space:nowrap;}", plume_ui__WEBPACK_IMPORTED_MODULE_1__.mq.large, "{white-space:", nowrap ? "nowrap" : "pre-wrap", ";}", omitted && omittedStyle),
            children: props.empty ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(EmptySymbol, {}) : props.children
        })
    });
};
var EmptySymbol = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("text-align:center;margin-left:25px;"),
        children: "-"
    });
};
var omittedStyle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("max-height:calc(14px * 1.4 * 3);-webkit-line-clamp:3;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;");
var TableHeading = function(_param) {
    var _align = _param.align, align = _align === void 0 ? "left" : _align, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "align"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("th", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("text-align:", align, ";", props.width && "width: ".concat(props.width, ";")),
        className: props.className,
        "data-test-id": props.dataTestId,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;align-items:center;", props.justify && "justify-content: ".concat(props.justify, ";")),
            children: [
                props.children,
                props.sub && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(SubLabel, {
                    children: props.sub
                }),
                props.help && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_common_Help__WEBPACK_IMPORTED_MODULE_2__/* .Help */ .W, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props.helpProps), {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin-left:3px;"),
                    children: props.help
                }))
            ]
        })
    });
};
var SubLabel = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("font-size:12px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.normal */ .LZ.weight.normal, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.textStrong */ .O9.textStrong, ";margin-left:3px;line-height:1.5;"),
        children: "（".concat(props.children, "）")
    });
};


/***/ }),

/***/ 93536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ DatePicker; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95570);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78966);
/* harmony import */ var date_fns_locale_ja__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40944);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9198);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_datepicker__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _IcomoonIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96747);











var DatePicker = function(props) {
    var ref;
    var onDelete = props.onDelete;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("box-shadow:0px 0px 10px rgba(0,0,0,0.1);> div{", ((ref = props.className) === null || ref === void 0 ? void 0 : ref.includes("first-interview-calender")) && " background: white;", "}// Override react-datepicker's style\n        .react-datepicker{font-family:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.family */ .LZ.family, ";border:none;}.react-datepicker__month-container{padding:10px 0px 5px;}.react-datepicker__header{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";border-bottom:none;margin-bottom:-8px;}.react-datepicker__day-name,.react-datepicker__day,.react-datepicker__time-name{line-height:28px;width:28px;margin:5px;}.react-datepicker__day{border-radius:50%;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.text */ .O9.text, ";transition:background-color 0.3s;&:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";}&:focus{outline:none;}}.react-datepicker__day--outside-month{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray60 */ .O9.gray60, ";}.react-datepicker__day--selected{border-radius:50%;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.cyan60 */ .O9.cyan60, ";color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";&:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.cyan60 */ .O9.cyan60, ";}}div.react-datepicker__day--today{font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.normal */ .LZ.weight.normal, ";border:1px solid ", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.cyan60 */ .O9.cyan60, " !important;width:30px;}.react-datepicker__day--today.react-datepicker__day--selected{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, " !important;}.react-datepicker__day-name{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textLight */ .O9.textLight, ";font-size:12px;}.react-datepicker__day--disabled{color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray60 */ .O9.gray60, ";&:hover{background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.white00 */ .O9.white00, ";}}"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((react_datepicker__WEBPACK_IMPORTED_MODULE_6___default()), {
                dateFormat: "yyyy-MM-dd",
                showMonthDropdown: true,
                showYearDropdown: true,
                dropdownMode: "select",
                inline: true,
                disabledKeyboardNavigation: true,
                locale: date_fns_locale_ja__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                selected: props.selected,
                maxDate: props.maxDate,
                minDate: props.minDate,
                onChange: props.onChange,
                renderCustomHeader: function(args) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CustomHeader, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, args), {
                        minDate: props.minDate,
                        maxDate: props.maxDate
                    }));
                }
            }),
            onDelete && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;justify-content:flex-end;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                    className: "clear-date-button",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, ";margin-right:16px;margin-bottom:16px;font-size:12px;cursor:pointer;:hover{text-decoration:underline;}"),
                    onClick: function() {
                        return onDelete();
                    },
                    children: "選択内容をクリア"
                })
            })
        ]
    });
};
var CustomHeader = function(props) {
    var minYear = props.minDate ? (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.minDate) : (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(new Date()) - 30;
    var maxYear = props.maxDate ? (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.maxDate) : (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(new Date()) + 10;
    var years = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.range)(minYear, maxYear + 1);
    var months = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.range)(1, 13);
    var handlePrevMonthClick = function() {
        if (!props.prevMonthButtonDisabled) {
            props.decreaseMonth();
        }
    };
    var handleNextMonthClick = function() {
        if (!props.nextMonthButtonDisabled) {
            props.increaseMonth();
        }
    };
    var handleChangeYear = function(year) {
        if (props.maxDate && year === (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.maxDate)) {
            // 今日の日付が渡された場合、表示する月を今月に制限する
            months = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.range)(1, (0,date_fns__WEBPACK_IMPORTED_MODULE_11__["default"])(props.maxDate) + 2);
        } else {
            months = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.range)(1, 13);
        }
        props.changeYear(year);
    };
    var handleChangeMonth = function(month) {
        if (props.maxDate && (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.date) === (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.maxDate) && month > (0,date_fns__WEBPACK_IMPORTED_MODULE_11__["default"])(props.maxDate)) {
            return; // 今日の日付が渡された場合、maxDateの月を超える月の選択は許可しない
        }
        props.changeMonth(months.indexOf(month));
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("display:flex;align-items:center;justify-content:space-between;padding:5px 10px;"),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                onClick: handlePrevMonthClick,
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;color:", props.prevMonthButtonDisabled ? plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray60 */ .O9.gray60 : plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black10 */ .O9.black10, ";transition:background-color 0.3s;", !props.prevMonthButtonDisabled && "\n            &:hover {\n              cursor: pointer;\n              background-color: ".concat(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";\n          ")),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_3__/* .IcomoonIcon */ .g, {
                    name: "arrow4-left"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Select, {
                        value: (0,date_fns__WEBPACK_IMPORTED_MODULE_10__["default"])(props.date),
                        onChange: function(param) {
                            var target = param.target;
                            return handleChangeYear(parseInt(target.value));
                        },
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("width:85px;margin-right:3px;"),
                        children: years.map(function(option) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("option", {
                                value: option,
                                children: "".concat(option, "年")
                            }, option);
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Select, {
                        value: months[(0,date_fns__WEBPACK_IMPORTED_MODULE_11__["default"])(props.date)],
                        onChange: function(param) {
                            var target = param.target;
                            handleChangeMonth(parseInt(target.value));
                        },
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("width:65px;"),
                        children: months.map(function(option) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("option", {
                                value: option,
                                children: "".concat(option, "月")
                            }, option);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                className: "next-month-button",
                onClick: handleNextMonthClick,
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;color:", props.nextMonthButtonDisabled ? plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray60 */ .O9.gray60 : plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black10 */ .O9.black10, ";transition:background-color 0.3s;", !props.nextMonthButtonDisabled && "\n            &:hover {\n              cursor: pointer;\n              background-color: ".concat(plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";\n          ")),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_IcomoonIcon__WEBPACK_IMPORTED_MODULE_3__/* .IcomoonIcon */ .g, {
                    name: "arrow4-right"
                })
            })
        ]
    });
};
var Select = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("select", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        className: props.className,
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("border:none;font-size:14px;padding:5px 6px;border-radius:2px;transition:background-color 0.3s;&:focus{outline:none;}&:hover{cursor:pointer;background-color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray40 */ .O9.gray40, ";}")
    }));
};


/***/ }),

/***/ 56162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ FollowButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _atoms_CheckIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44117);
/* harmony import */ var _atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96747);
/* harmony import */ var _atoms_LoadableButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84044);










var FollowButton = function(_param) {
    var _theme = _param.theme, theme = _theme === void 0 ? "light-bg" : _theme, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "theme"
    ]);
    return props.isFollowed ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(FollowedButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        theme: theme
    }, props), {
        className: "follow-button"
    })) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(ToFollowButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        theme: theme
    }, props), {
        className: "follow-button"
    }));
};
var FollowedButton = function(props) {
    var color = "#1b8298";
    var hoverBgColor = "#00596A";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_atoms_LoadableButton__WEBPACK_IMPORTED_MODULE_4__/* .LoadableButton */ .L, {
        size: "small",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("flex-shrink:0;color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";border:1px solid ", color, ";background-color:", color, ";display:flex;column-gap:2px;justify-content:center;align-items:center;padding-block:6px !important;padding-inline:13.5px !important;font-size:12px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";line-height:1;letter-spacing:0.02em;white-space:nowrap;&:hover{color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00, ";background-color:", hoverBgColor, ";border-color:", hoverBgColor, ";}& > i{font-size:14px;}"),
        className: props.className,
        onClick: props.onUnfollow,
        isLoading: props.isLoading,
        spinnerColor: plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_CheckIcon__WEBPACK_IMPORTED_MODULE_2__/* .CheckIcon */ .n, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
                children: "フォロー中"
            })
        ]
    });
};
var ToFollowButton = function(props) {
    var color = props.theme === "light-bg" ? "#1b8298" : plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00;
    var bgColor = props.theme === "light-bg" ? plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00 : "transparent";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_atoms_LoadableButton__WEBPACK_IMPORTED_MODULE_4__/* .LoadableButton */ .L, {
        size: "small",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("flex-shrink:0;color:", color, ";border:1px solid ", color, ";background-color:", bgColor, ";display:flex;column-gap:2px;justify-content:center;align-items:center;padding-block:6px !important;padding-inline:13.5px !important;font-size:12px !important;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .font.weight.bold */ .LZ.weight.bold, ";line-height:1;letter-spacing:0.02em;white-space:nowrap;&:hover{color:", props.disabled ? color : "#2da5be", ";border-color:", props.disabled ? color : "#2da5be", ";background-color:", bgColor, ";cursor:", props.disabled ? "default" : "pointer", ";}& > i{font-size:14px;}"),
        className: props.className,
        onClick: props.onFollow,
        isLoading: props.isLoading,
        spinnerColor: color,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(PlusIcon, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
                children: "フォロー"
            })
        ]
    });
};
var PlusIcon = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_3__/* .IcomoonIcon */ .g, {
        name: "plus"
    });
};


/***/ }),

/***/ 33869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Help; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96747);





var Help = function(props) {
    var ref;
    if (props.linkTo) {
        var ref1;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
                label: props.children ? (ref1 = props.children) === null || ref1 === void 0 ? void 0 : ref1.toString() : "",
                id: "help",
                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("line-height:1;"),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("a", {
                    href: props.linkTo,
                    target: "_blank",
                    rel: "noopener",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";vertical-align:middle;&:active,&:visited{color:", plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.black10 */ .O9.black10, ";}"),
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Icon, {
                        text: props.children,
                        className: props.className,
                        size: props.size,
                        offset: props.offset
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
            label: props.children ? (ref = props.children) === null || ref === void 0 ? void 0 : ref.toString() : "",
            id: "help",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("line-height:1;"),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Icon, {
                text: props.children,
                className: props.className,
                size: props.size,
                offset: props.offset
            })
        })
    });
};
var Icon = function(props) {
    var ref;
    var offset = "{'top': ".concat(((ref = props.offset) === null || ref === void 0 ? void 0 : ref.top) || 0, "}");
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
        "data-for": "help",
        "data-offset": offset,
        "data-tip": props.text,
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_2__/* .IcomoonIcon */ .g, {
            name: "question-circle-fill",
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)("font-size:", props.size === "large" ? "20px" : "14px", ";")
        })
    });
};


/***/ }),

/***/ 41181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fk": function() { return /* binding */ toUnitNumber; },
/* harmony export */   "Km": function() { return /* binding */ thousandToMillion; },
/* harmony export */   "dN": function() { return /* binding */ formatAmount; },
/* harmony export */   "ii": function() { return /* binding */ millionToThousand; },
/* harmony export */   "m$": function() { return /* binding */ formatWithComma; }
/* harmony export */ });
/* unused harmony export inThousand */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39693);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_compact__WEBPACK_IMPORTED_MODULE_0__);


var formatWithComma = function(n, options) {
    if (n === null || n === undefined) {
        return "";
    }
    var ref = options || {}, _decimalPlace = ref.decimalPlace, decimalPlace = _decimalPlace === void 0 ? 0 : _decimalPlace;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(n.toFixed(decimalPlace).split("."), 2), base = ref1[0], decimalDigits = ref1[1];
    var formatted = base.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return lodash_compact__WEBPACK_IMPORTED_MODULE_0___default()([
        formatted,
        decimalDigits
    ]).join(".");
};
var inThousand = function(n) {
    var numberInThousand = Math.round(n / 1000);
    return formatWithComma(numberInThousand);
};
var millionToThousand = function(i) {
    return i ? i * 1000 : null;
};
var thousandToMillion = function(n) {
    return n ? Number(n * 0.001) : null;
};
var formatAmount = function(n) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        estimated: false
    };
    if (n === null || n === 0) {
        return null;
    }
    if (options.estimated) {
        if (n / 1000 >= 1) {
            return {
                value: "".concat(formatWithComma(thousandToMillion(n))),
                unit: "百万円（推定）"
            };
        }
        return {
            value: "".concat(formatWithComma(n)),
            unit: "千円（推定）"
        };
    } else {
        if (n / 1000 >= 1) {
            return {
                value: "".concat(formatWithComma(thousandToMillion(n))),
                unit: "百万円"
            };
        }
        return {
            value: "".concat(formatWithComma(n)),
            unit: "千円"
        };
    }
};
var toUnitNumber = function(num) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (num >= 1000000000000) return {
        value: divideAndRound(num, 1000000000000, precision),
        unit: "T"
    };
    if (num >= 1000000000) return {
        value: divideAndRound(num, 1000000000, precision),
        unit: "B"
    };
    if (num >= 1000000) return {
        value: divideAndRound(num, 1000000, precision),
        unit: "M"
    };
    if (num >= 1000) return {
        value: divideAndRound(num, 1000, precision),
        unit: "K"
    };
    return {
        value: num,
        unit: null
    };
};
var divideAndRound = function(value, divisionNum, precision) {
    var n = Math.pow(10, precision);
    return Math.floor(value * n / divisionNum) / n;
};


/***/ }),

/***/ 15598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ IGNORED_BY_WOVN_CLASS_NAME; }
/* harmony export */ });
var IGNORED_BY_WOVN_CLASS_NAME = "wovn-ignore";


/***/ }),

/***/ 61753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70655);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_common_Template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33431);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56902);
/* harmony import */ var _lib_gtm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11543);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18584);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96747);













var Error = function(param) {
    var _statusCode = param.statusCode, statusCode = _statusCode === void 0 ? 404 : _statusCode, err = param.err;
    var msg = msgOf(statusCode);
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .a)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var errorMessage = "".concat(err === null || err === void 0 ? void 0 : err.name, " ").concat(err === null || err === void 0 ? void 0 : err.message);
        console.log("error", errorMessage);
        (0,_lib_gtm__WEBPACK_IMPORTED_MODULE_5__/* .pushEventToGTM */ .K)(user, _lib_tracking__WEBPACK_IMPORTED_MODULE_4__/* .ERROR */ .pn, errorMessage);
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_common_Template__WEBPACK_IMPORTED_MODULE_1__/* .Template */ .Y, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("text-align:center;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black30 */ .O9.black30, ";padding:0 15px;"),
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    id: "error-page-error-code",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("font-size:100px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                    children: msg.statusCodeForDisplay
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("font-size:28px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                    children: msg.title
                }),
                msg.image && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("img", {
                    src: msg.image,
                    alt: "Error Image",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{margin-top:64px;}width:240px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{width:320px;}")
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textLight */ .O9.textLight, ";font-size:16px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{font-size:18px;}"),
                    "data-test-id": "error-page-description",
                    children: msg.description
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("a", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;margin-bottom:40px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{margin-bottom:64px;}display:flex;align-items:center;justify-content:center;"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_7__/* .IcomoonIcon */ .g, {
                                name: "arrow-back",
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, ";font-size:14px;padding-right:4px;")
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, ";font-size:14px;"),
                                children: "トップに戻る"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var msgOf = function(statusCode) {
    switch(statusCode){
        case 403:
            return {
                title: "FORBIDDEN",
                description: "このページへのアクセスは禁止されています。"
            };
        case 404:
            return {
                image: "/static/images/error/illust-404.png",
                description: "お探しのページは見つかりませんでした。"
            };
        case 500:
        default:
            return {
                statusCodeForDisplay: 500,
                title: "INTERNAL SERVER ERROR"
            };
    }
};
var handleTrailingSlash = function(req, res) {
    if (req.url) {
        var urlParts = req.url.split("?");
        if (urlParts[0].endsWith("/")) {
            urlParts[0] = urlParts[0].substring(0, urlParts[0].length - 1);
            res.writeHead(301, {
                Location: urlParts.join("?")
            });
            res.end();
        }
    }
};
Error.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(ctx) {
        var req, res, err, statusCode;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            req = ctx.req, res = ctx.res, err = ctx.err;
            statusCode = res ? res.statusCode : err ? err.statusCode : 404;
            if (statusCode === 404 && req && res) {
                handleTrailingSlash(req, res);
            }
            if (res) {
                // Running on the server
                if (statusCode === 404) {
                    return [
                        2,
                        {
                            statusCode: 404
                        }
                    ];
                }
            }
            return [
                2,
                {
                    statusCode: statusCode,
                    err: err
                }
            ];
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (Error);


/***/ })

}]);